import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Header, Inline, PageTitle, Suggestions } from '../Content/Content.style'
import { withSize } from '../../../utils'
import { colors } from '../../../../constants'
import { Centered, List, Loader, Padding, Button, SearchInput } from '../../..'
import NextPage from '../../../Table/NextPage'
import MediaItem from './MediaItem'
import { SearchBoxContainer } from './Media.style'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as AppActions from '../../../../actions/app'

class ContentMedia extends Component {
    componentDidMount() {
        const { changePageTitle, inPlaylist, t } = this.props

        if (!inPlaylist) {
            changePageTitle(t('media'))
        }
    }

    media = () => {
        const { data } = this.props
        return data || []
    }

    selectedMedia = () => {
        const media = this.media()
        if (media && media.length) return media.filter((m) => m.selected).length
        return 0
    }

    onRemoveMedia = (mediaID, orderId) => {
        const { onRemoveMedia, t } = this.props
        const count = mediaID ? 1 : this.selectedMedia()

        // eslint-disable-next-line no-alert
        if (!window.confirm(t('ConfirmDeleteMedia', { count }))) {
            return null
        }

        if (onRemoveMedia) {
            onRemoveMedia(mediaID, orderId)
        }
    }

    /**
     * Custom media view render method
     * @param {String} keyBuilt Element key built in renderList method
     */
    renderMedia = (keyBuilt = '') => {
        const { bulkSelection, inPlaylist, inSelectedPlaylist, isDownloadBlocked, onDownloadMedia, onEditMedia, onInspectMedia, onRetryUpload } = this.props
        const media = this.media()
        const { id: playlistId } = inPlaylist || {}

        // Built key is defined as `<index>_<id>`, so taking the id from it
        const id = parseInt(keyBuilt.split('-').pop(), 10)

        // Looking for the selected media to render
        const mediaToRender = media.find((m) => m.id === id)

        if (!mediaToRender) {
            return null
        }

        return (
            <MediaItem
                key={id}
                inPlaylist={playlistId}
                inSelectedPlaylist={inSelectedPlaylist}
                onInspectMedia={onInspectMedia}
                onEdit={onEditMedia}
                onRetryUpload={onRetryUpload}
                onRemoveMedia={this.onRemoveMedia}
                isDownloadBlocked={isDownloadBlocked}
                onDownloadMedia={onDownloadMedia}
                media={mediaToRender}
                bulkSelection={bulkSelection}
            />
        )
    }

    renderList = () => {
        const { onDropMedia, isLoading, isMobile, nextPage, onDownloadMedia, t, twoColumns } = this.props
        const media = this.media()
        const buildKey = (index) => `${index}-${media[index].id}`

        return (
            <div
                style={{
                    paddingBottom: '220px',
                }}
            >
                <List
                    buildKey={buildKey}
                    data={media}
                    display="name"
                    draggable={!!onDropMedia}
                    itemRenderer={this.renderMedia}
                    marginBottom="14px"
                    onDownload={onDownloadMedia}
                    onDrop={onDropMedia}
                    onRemove={this.onRemoveMedia}
                    width={twoColumns && !isMobile ? '50%' : null}
                />
                {isLoading && (
                    <Centered horizontal>
                        <Loader />
                    </Centered>
                )}
                {!isLoading && nextPage && (
                    <NextPage ref={this.scrollRef} onClick={nextPage}>
                        {`${t('Load more')}...`}
                    </NextPage>
                )}
            </div>
        )
    }

    renderDeleteButton = () => {
        const { inPlaylist, t } = this.props
        const selectedMedia = this.selectedMedia()
        if (selectedMedia && !inPlaylist)
            return (
                <Button onClick={() => this.onRemoveMedia(null)} theme="danger" radius={5} style={{ padding: '9px 10px 8px' }}>
                    {t('RemoveMediaButton', { count: selectedMedia })}
                </Button>
            )
    }

    render() {
        const {
            backGroundColor,
            children,
            countPendingApproval,
            countPendingPush,
            countPendingTest,
            inPlaylist,
            isLoading,
            isMobile,
            isPendingApprovFilterEnabled,
            isPendingPushFilterEnabled,
            isPendingTestFilterEnabled,
            onChangeMedia,
            onChangeSearch,
            onClickPendingApprovalFilter,
            onClickPendingPushFilter,
            onClickPendingTestFilter,
            onOpenFormMedia,
            onTextChangeMedia,
            optionsMedia,
            t,
            valueSearch,
        } = this.props
        const selectedMedia = this.selectedMedia()
        const { name: playlistName } = inPlaylist || {}

        const pendingApprovalTheme = isPendingApprovFilterEnabled
            ? 'yellow'
            : 'disabled';
        const pendingTestTheme = isPendingTestFilterEnabled
            ? 'yellow'
            : 'disabled';
        const pendingPushTheme = isPendingPushFilterEnabled
            ? 'yellow'
            : 'disabled';

        return (
            <div
                style={{
                    backgroundColor: backGroundColor || colors.bluedarkest,
                    height: '100%',
                    overflowY: 'scroll',
                    width: '100%',
                }}
            >
                <div style={{ height: '38px', backgroundColor: '#f1f1f1', width: '100%' }}></div>
                <Header style={{ backgroundColor: 'white', color: 'darkPrimary' }} bottom left size="md">
                    {inPlaylist && (
                        <PageTitle>
                            {playlistName}
                            <span className="names-separator">&nbsp;&gt;&nbsp;</span>
                            {t('media')}
                        </PageTitle>
                    )}
                    {!inPlaylist && t('media')}
                </Header>
                <div style={{ backgroundColor: '#3e7dc0', color: 'white' }}>
                    <Padding left right size={isMobile ? 'sm' : 'md'}>
                        <Padding top bottom right size="ssm">
                            <Padding right inline style={{ width: '50%' }}>
                                <div style={{ margin: '7px' }}>
                                    {!isLoading && <>Showing {this.media().length} Media files</>}
                                </div>
                            </Padding>
                            <Inline style={{ width: '50%' }}>
                                {!inPlaylist && (
                                    <SearchBoxContainer>
                                        <SearchInput
                                            onChange={onChangeSearch}
                                            value={valueSearch}
                                            width="100%"
                                        />
                                    </SearchBoxContainer>
                                )}
                            </Inline>
                        </Padding>
                    </Padding>
                </div>
                <div style={{ backgroundColor: '#FFFFFF', color: '#215982', }}>
                    <Padding left right size={isMobile ? 'sm' : 'md'}>
                        <Padding top bottom size="ssm">
                            <div style={{ display: 'inline-block', width: isMobile ? '100%' : '50%' }}>
                                <Button
                                    fullWidth={isMobile}
                                    onClick={selectedMedia && !inPlaylist ? () => this.onRemoveMedia(null) : onOpenFormMedia}
                                    theme={selectedMedia && inPlaylist ? 'danger' : 'forestGreen'}
                                    style={{ padding: '10px 20px' }}
                                >
                                    {selectedMedia && inPlaylist ? t('RemoveMediaButton', { count: selectedMedia }) : t('UploadNewMedia')}
                                </Button>
                            </div>
                            <Padding
                                top
                                inline={!isMobile}
                                style={{
                                    textAlign: 'right',
                                    width: isMobile ? '100%' : '50%',
                                    display: 'inline-flex', 
                                    justifyContent: isMobile ? 'center' : 'flex-end',
                                }}
                            >
                                {inPlaylist && (
                                    <Suggestions
                                        type="suggestions"
                                        onChange={onChangeMedia}
                                        onTextChange={onTextChangeMedia}
                                        options={optionsMedia}
                                        placeholder={t('AddExistingMedia')}
                                    />
                                )}
                                {this.renderDeleteButton()}
                                {onClickPendingApprovalFilter && !isLoading && (
                                    <Button
                                        onClick={onClickPendingApprovalFilter}
                                        theme={pendingApprovalTheme}
                                        fontSize="13px"
                                        style={{ padding: '10px 20px', display: isMobile ? 'inline-block' : 'block', flex: 1, maxWidth: '180px' }}
                                    >
                                        {countPendingApproval}&nbsp;{t('media-pending-approval-show')}
                                    </Button>
                                )}
                                {onClickPendingTestFilter && !isLoading && (
                                    <Button
                                        onClick={onClickPendingTestFilter}
                                        theme={pendingTestTheme}
                                        fontSize="13px"
                                        style={{ padding: '10px 20px', display: isMobile ? 'inline-block' : 'block', flex: 1, maxWidth: '180px' }}
                                    >
                                        {countPendingTest}&nbsp;{t('media-pending-test-show')}
                                    </Button>
                                )}
                                {onClickPendingPushFilter && !isLoading && (
                                    <Button
                                        onClick={onClickPendingPushFilter}
                                        theme={pendingPushTheme}
                                        fontSize="13px"
                                        style={{ padding: '10px 20px', display: isMobile ? 'inline-block' : 'block', flex: 1, maxWidth: '180px' }}
                                    >
                                        {countPendingPush}&nbsp;{t('media-pending-push-show')}
                                    </Button>
                                )}
                            </Padding>
                        </Padding>
                    </Padding>
                </div>
                <div style={{ backgroundColor: '#092c46', color: '#FFFFFF' }}>
                    <Padding
                        top
                        left
                        right
                        bottom
                        size={isMobile ? 'sm' : 'md'}
                        height={!inPlaylist ? 'calc(100% - 154px)' : 'calc(100% - 244px)'}
                    >
                        <Padding bottom size="xs" height="100%">
                            {this.renderList()}
                        </Padding>
                    </Padding>
                    {children}
                </div>
            </div>
        )
    }
}

ContentMedia.propTypes = {
    backGroundColor: PropTypes.string,
    bulkSelection: PropTypes.func,
    changePageTitle: PropTypes.func.isRequired,
    children: PropTypes.node,
    countPendingApproval: PropTypes.number,
    countPendingPush: PropTypes.number,
    countPendingTest: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    inPlaylist: PropTypes.shape({}),
    inSelectedPlaylist: PropTypes.bool,
    isDownloadBlocked: PropTypes.bool,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool.isRequired,
    isPendingApprovFilterEnabled: PropTypes.bool,
    isPendingPushFilterEnabled: PropTypes.bool,
    isPendingTestFilterEnabled: PropTypes.bool,
    nextPage: PropTypes.func,
    onChangeMedia: PropTypes.func,
    onChangeSearch: PropTypes.func,
    onClickPendingApprovalFilter: PropTypes.func,
    onClickPendingPushFilter: PropTypes.func,
    onClickPendingTestFilter: PropTypes.func,
    onDownloadMedia: PropTypes.func,
    onDropMedia: PropTypes.func,
    onEditMedia: PropTypes.func,
    onInspectMedia: PropTypes.func,
    onOpenFormMedia: PropTypes.func,
    onRemoveMedia: PropTypes.func,
    onRenderButtonClick: PropTypes.func,
    onRetryUpload: PropTypes.func,
    onTextChangeMedia: PropTypes.func,
    optionsMedia: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.string,
        })
    ),
    t: PropTypes.func.isRequired,
    twoColumns: PropTypes.bool,
    valueSearch: PropTypes.string,
}

ContentMedia.defaultProps = {
    backGroundColor: null,
    bulkSelection: () => null,
    children: null,
    countPendingApproval: null,
    countPendingPush: null,
    countPendingTest: null,
    data: null,
    inPlaylist: null,
    inSelectedPlaylist: false,
    isDownloadBlocked: false,
    isLoading: false,
    isPendingApprovFilterEnabled: false,
    isPendingPushFilterEnabled: false,
    isPendingTestFilterEnabled: false,
    nextPage: null,
    onChangeMedia: () => null,
    onChangeSearch: () => null,
    onClickPendingApprovalFilter: null,
    onClickPendingPushFilter: null,
    onClickPendingTestFilter: null,
    onDownloadMedia: () => null,
    onDropMedia: null,
    onEditMedia: () => null,
    onInspectMedia: () => null,
    onOpenFormMedia: () => null,
    onRemoveMedia: () => null,
    onRenderButtonClick: null,
    onRetryUpload: () => null,
    onTextChangeMedia: () => null,
    optionsMedia: [],
    twoColumns: false,
    valueSearch: null,
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            changePageTitle: AppActions.changePageTitle,
        },
        dispatch
    )


export default connect(null, mapDispatchToProps)(withTranslation()(withSize(ContentMedia)))
